module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=DZ - Algeria.29e6aeb7.svg";